export type MatchSplit = {
  before: string
  match: string
  after: string
}

/**
 * Splits `label` around the first case-insensitive occurrence of `query`, so
 * the matched text can be rendered differently. With no query or no match the
 * whole label comes back as `before`.
 */
export const splitByMatch = (label: string, query: string): MatchSplit => {
  const needle = query.trim()
  const start = needle ? label.toLowerCase().indexOf(needle.toLowerCase()) : -1
  if (start === -1) return { before: label, match: '', after: '' }

  const end = start + needle.length
  return {
    before: label.slice(0, start),
    match: label.slice(start, end),
    after: label.slice(end),
  }
}
